(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["arctic-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('arctic-mega-menu')) {
    class ArcticMegaMenu extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleFilter);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleFilter);
      }

      handleFilter = (event) => {
        const button = event.target.closest('[data-brand-filter]');
        if (!button || !this.contains(button)) return;

        const filter = button.dataset.brandFilter;
        const links = this.querySelectorAll('[data-brand-initial]');
        const buttons = this.querySelectorAll('[data-brand-filter]');

        buttons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        links.forEach((link) => {
          link.hidden = filter !== 'all' && link.dataset.brandInitial !== filter;
        });
      };
    }

    customElements.define('arctic-mega-menu', ArcticMegaMenu);
  }
  } catch(e) { console.error(e); }
})();

})();
